<template>
  <v-container fluid>
    <v-card>
      <PageTitle text="Desempenho por módulo">
        <template #suffixTitle>
          <BtnInfo :tooltip-text="STUDENT_MODULE_METRICS_INFO" />
          <UpdatedAt :date="last_updated_at" />
        </template>
      </PageTitle>
      <v-container fluid>
        <v-row>
          <v-col md="3">
            <v-select
              v-model="subject_id"
              :items="subjects"
              filled
              dense
              item-text="name"
              item-value="id"
              clearable
              class="custom-filter-select w-100"
              placeholder="Filtro: Disciplina"
            />
          </v-col>
          <v-col md="4">
            <SearchFilter
              v-model="search"
              placeholder="Pesquisar por nome do módulo"
            />
          </v-col>
          <v-col
            md="5"
            class="text-right"
          >
            <v-btn
              rounded
              class="text-white"
              color="nitro"
              @click.prevent="printPdf(`${url}`)"
            >
              Imprimir Boletim
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <v-card-text>
        <v-container
          v-for="(cycle) of filteredCycles"
          :key="cycle.index"
          fluid
        >
          <v-row>
            <v-col>
              <p>
                <span class="font-weight-bold"> Ciclo {{ cycle.order }}: </span>
                {{ `${$moment(cycle.begin).format('DD [de] MMMM')} até ${$moment(cycle.end).format('DD [de] MMMM')}` }}
              </p>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="cycle.modules"
            :search="search"
            hide-default-footer
            style="background-color: #E7E9EF"
          >
            <template
              v-for="(item, index) in headers.filter(h => h.tooltip)"
              #[`header.${item.value}`]="{ header }"
            >
              <v-tooltip
                :key="index"
                bottom
              >
                <template #activator="{ on }">
                  <span v-on="on">{{ item.text }} <i :class="item.icon" /> </span>
                </template>
                <span>{{ item.tooltip }}</span>
              </v-tooltip>
            </template>
            <template #item.performance="{ item }">
              {{ cycle.challenge_finished_at ? `${item.performance}%` : '-' }}
            </template>
            <template #item.goal_progress="{ item }">
              {{ item.goal_progress }}%
            </template>

            <template #footer>
              <v-container fluid>
                <v-row
                  class="text-center py-3 result"
                >
                  <v-col>
                    <span class="h4 font-weight-bold h6">
                      Resultado alcançado
                    </span>
                    <BtnInfo tooltip-text="Média aritmética da soma das notas de progresso e de desempenho em todos os módulos do ciclo dividida pela quantidade de módulos no ciclo" />
                  </v-col>
                  <v-col
                    md="3"
                    lg="3"
                    class="text-center"
                  >
                    <span class="h4 font-weight-bold h6">
                      {{ cycle.goal_progress }}%
                    </span>
                  </v-col>
                  <v-col
                    md="3"
                    lg="3"
                    class="text-center"
                  >
                    <span class="h4 font-weight-bold h6">
                      {{ cycle.challenge_finished_at ? `${cycle.performance}%`: '-' }}
                    </span>
                  </v-col>
                </v-row>
              </v-container>
              <v-container fluid>
                <v-row class="text-center py-3 overall-performance">
                  <v-col
                    class="text-center"
                    cols="12"
                  >
                    <div>
                      <span class="h4 font-weight-bold h6">
                        Score Nitro: {{ cycle.score_weight_configured ? `${cycle.cycle_score}%` : '-' }}
                      </span>
                      <BtnInfo tooltip-text="Nota média do ciclo considerando a aplicação dos pesos nos critérios progresso e desempenho" />
                    </div>
                    <div>
                      Score: <span class="text-nitro font-weight-bold">{{ cycle.score_weight_configured ? `${cycle.module_score_weight * 100}%`: '-' }}</span> de progresso /
                      <span class="text-nitro font-weight-bold">{{ cycle.score_weight_configured ? `${cycle.challenge_score_weight * 100}%`: '-' }}</span> de desempenho
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </template>
          </v-data-table>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import SearchFilter from "@/school/components/SearchFilter";
import PageTitle from "@/common/components/PageTitle";
import {formatHour} from "@/filters/customFormatHours";
import printJS from 'print-js';
import BtnInfo from '@/common/components/BtnInfo';
import {STUDENT_MODULE_METRICS_INFO} from "@/constants/messages_info.js";
import UpdatedAt from "@/common/components/UpdatedAtComponent"

export default {
  components: {
    BtnInfo,
    SearchFilter,
    PageTitle,
    UpdatedAt,
},
  data() {
    return {
      STUDENT_MODULE_METRICS_INFO,
      subject_id: '',
      search: '',
      headers: [
          { text: 'Disciplina/Carreira',value: 'subject.name', width: 150},
          { text: 'Bloco temático',value: 'block.name', width: 150},
          { text: 'Módulo', value: 'name' , width: 500},
          { text: 'Progresso no módulo', value: 'goal_progress', align: 'center', icon: 'fas fa-question-circle', tooltip: "Progresso alcançado até a data de meta de conclusão do módulo do ciclo" },
          { text: 'Desempenho no desafio', value: 'performance', align: 'center', icon: 'fas fa-question-circle', tooltip: "Nota alcançada do aluno no desafio do ciclo" },
        ],
    }
  },
  computed: {
    ...mapGetters(['selectedYear',"subjects","cycles","report_logs"]),
    last_updated_at(){
      return this.report_logs.find(r => r.report_table == "module_student_rating").last_update
    },
    url() {
      return `/api/v1/student/school_report`
    },
    filteredCycles(){
      let cycles = _.cloneDeep(this.cycles);
      return this.subject_id || this.search.length ? cycles
          .map(c => {
            if(this.search) {
              c.modules = c.modules.filter(m=> m.name.toLowerCase().includes(this.search.toLowerCase()));
            }
            if(this.subject_id) {
              c.modules = c.modules.filter(m=>m.subject.id == this.subject_id);
            }
            return c;
          })
          .filter(c=>{
            return c.modules.length;
          }): this.cycles;
    }
  },
  created() {
    if(!this.subjects.length)
      this.getSubjects();
  },
  methods: {
    ...mapActions([
      'getSubjects',
      'isLoading'
    ]),
    formatHour,
    printPdf() {
      this.isLoading()
      this.getPdf().then(response => {
        response.blob().then(function (blob) {
          let reader = new FileReader();
          reader.onload = function () {
            printJS({
              printable: reader.result.substring(28),
              type: 'pdf',
              base64: true
            });
          };
          reader.readAsDataURL(blob);
        })
      }).finally(() => this.isLoading( false ))
    },
    getPdf() {
      return fetch(`/api/v1/student/cycle/export-bulletin?year=${this.selectedYear}`)
    }
  }
}
</script>

<style scoped>
.overall-performance {
  background-color: #B2B9CB;
}
.result {
  background-color: #ccd1dd;
}
</style>
